import React, {useContext, useEffect, useState} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import {BackendContext} from "../components/BackendContext";
import {Lead} from "../SharedTypes";
import {makeStyles} from "@material-ui/core/styles";
import Clear from "@material-ui/icons/Clear";
import {format} from "date-fns";


const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650,
    },
    container: {
        margin: 'auto',
        marginTop: theme.spacing(2),
        // maxWidth: theme.breakpoints.values.md,
    },
    formContainer: {
        margin: 'auto',
        marginTop: theme.spacing(4),
        maxWidth: theme.breakpoints.values.md,
        padding: theme.spacing(4),
    },
    infoColor: {
        color: theme.palette.info.dark
    },
    dangerColor: {
        color: theme.palette.error.dark
    },
    title: {
        flexGrow: 1,
    },
}));

function ListLeads() {
    const backendApi = useContext(BackendContext),
        classes = useStyles(),
        [leads, setLeads] = useState<Lead[]>([]);

    useEffect(() => {
        backendApi.listLeads().then(setLeads);
    }, [backendApi]);

    async function reloadLeads() {
        return backendApi.listLeads().then(setLeads);
    }

    return (
        <TableContainer component={Paper} className={classes.container}>
            <Typography component="h2" variant="h4" style={{margin: '1rem'}}>Leads</Typography>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell component="th">Date</TableCell>
                        <TableCell component="th">Floor Plan</TableCell>
                        <TableCell/>
                        <TableCell component="th">Name</TableCell>
                        <TableCell component="th">Email</TableCell>
                        <TableCell component="th">Phone</TableCell>
                        <TableCell component="th" align="right"/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {leads.map(lead => <TableRow key={lead.id}>
                        <TableCell>{format(new Date(lead.date), 'M/d/yyyy h:mm a')}</TableCell>
                        <TableCell>{lead.floorPlanName}</TableCell>
                            <TableCell><Button component="a" href={lead.optionsFileUrl} color="primary">View Options</Button></TableCell>
                        <TableCell>{lead.name}</TableCell>
                        <TableCell>{lead.email}</TableCell>
                        <TableCell>{lead.phone}</TableCell>
                        <TableCell>
                            <Tooltip title="Remove Lead">
                                <IconButton onClick={async () => {
                                    await backendApi.deleteLead(lead.id);
                                    await reloadLeads();
                                }}>
                                    <Clear className={classes.dangerColor}/>
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default ListLeads;